module.exports = __webpack_public_path__ + "static/img/dkhsqsh.48396d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/dkhsqsh.png
// module id = 1217
// module chunks = 0